import { Color } from '@tmh-website/shared/colors';
import StyledTypo from '@tmh-website/styles/typo';
import Link from 'next/link';
import transparentize from 'polished/lib/color/transparentize';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 40px 0 0;
  @media (${props => props.theme.breakpoint.md.up}) {
    flex-direction: row;
    align-items: start;
  }

  > * {
    @media (${props => props.theme.breakpoint.md.up}) {
      margin-right: ${props => props.theme.gap.xLarge};

      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

export const CopyrightText = styled(StyledTypo.Typography)`
  order: 3;
  margin-top: 10px;
  text-align: center;
  @media (${props => props.theme.breakpoint.md.up}) {
    order: 1;
    margin-top: 0;
    text-align: left;
  }
`;

export const LogoLink = styled(Link)`
  display: none;
  @media (${props => props.theme.breakpoint.md.down}) {
    display: block;
    align-self: center;
    order: 2;
    padding: 8px 16px;
    line-height: 1;
    color: ${props => props.theme.color[Color.Neutral_0_White]};
    text-align: center;
    opacity: 1;
    transition: opacity ${props => props.theme.transitionTiming};

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const EntriesNav = styled.nav`
  order: 1;
  margin-bottom: 40px;
  @media (${props => props.theme.breakpoint.md.up}) {
    order: 3;
    margin-bottom: 0;
  }
`;

export const EntriesUl = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: -8px;
  list-style: none;
  @media (${props => props.theme.breakpoint.md.up}) {
    margin: -10px;
  }
`;

export const EntryLi = styled.li`
  margin: 8px;
  @media (${props => props.theme.breakpoint.md.up}) {
    margin: 10px;
  }
`;

export const AnchorLink = styled.a`
  ${StyledTypo.uiTextSmallCss};
  padding: 8px;
  margin: -8px;
  color: ${({ theme }) => transparentize(1 - theme.textOpacity, theme.color[Color.Neutral_0_White])};
  transition: color ${props => props.theme.transitionTiming};
  @media (${props => props.theme.breakpoint.md.up}) {
    padding: 4px;
    margin: -4px;
  }

  &:hover {
    color: ${props => props.theme.color[Color.Neutral_0_White]};
    text-decoration: none;
  }

  &:active {
    color: ${props => transparentize(0.6, props.theme.color[Color.Neutral_0_White])};
  }
`;
